export default function env(property) {
  if (!process.env[property]) {
    console.info(`INFO: ${property} env var don't exists in frontend process.env`);
    return false;
  }

  return process.env[property];
}
